import React, { useState } from "react";

const steps = [
  { number:"01", icon:"🔍", title:"Choose a Plan", description:"Browse our affordable plans starting from Rs 99/week and pick the one that fits your life." },
  { number:"02", icon:"📝", title:"Fill Your Details", description:"Enter your basic information in under 2 minutes. No agent or office visit needed." },
  { number:"03", icon:"💳", title:"Pay Online", description:"Pay securely via eSewa, Khalti, or ConnectIPS. Fast and safe." },
  { number:"04", icon:"🛡️", title:"Get Covered Instantly", description:"Receive your Himalayan Life Insurance backed policy certificate immediately in your inbox." },
];

function HowItWorks() {
  const [hovered, setHovered] = useState(null);

  return (
    <section id="howitworks" style={{padding:"80px 48px", background:"#fff"}}>
      <div style={{textAlign:"center", marginBottom:"56px"}}>
        <h2 style={{fontSize:"40px", fontWeight:"900", color:"#0f172a", marginBottom:"12px"}}>How It <span style={{background:"linear-gradient(135deg, #0d9488, #0891b2)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent"}}>Works</span></h2>
        <p style={{fontSize:"16px", color:"#64748b"}}>Get insured in 4 simple steps — takes less than 3 minutes</p>
      </div>
      <div style={{display:"flex", gap:"24px", justifyContent:"center", flexWrap:"wrap"}}>
        {steps.map((step, index) => (
          <div key={index}
            onMouseEnter={() => setHovered(index)}
            onMouseLeave={() => setHovered(null)}
            style={{textAlign:"center", width:"220px", padding:"32px 20px", borderRadius:"20px", background: hovered === index ? "#f0fdfa" : "#f8fafc", border: hovered === index ? "2px solid #0d9488" : "2px solid #e2e8f0", transition:"all 0.3s", transform: hovered === index ? "translateY(-8px)" : "translateY(0)", boxShadow: hovered === index ? "0 16px 40px rgba(13,148,136,0.12)" : "none", cursor:"default"}}>
            <div style={{width:"72px", height:"72px", borderRadius:"999px", background: hovered === index ? "linear-gradient(135deg, #0d9488, #0891b2)" : "#e6fffa", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 16px", fontSize:"32px", transition:"all 0.3s", boxShadow: hovered === index ? "0 8px 24px rgba(13,148,136,0.3)" : "none"}}>
              {step.icon}
            </div>
            <div style={{fontSize:"12px", fontWeight:"800", color:"#0d9488", letterSpacing:"2px", marginBottom:"8px"}}>{step.number}</div>
            <h3 style={{fontSize:"18px", fontWeight:"800", color:"#0f172a", marginBottom:"8px"}}>{step.title}</h3>
            <p style={{fontSize:"13px", color:"#64748b", lineHeight:"1.7"}}>{step.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default HowItWorks;